<template>
    <div class="image is-flex" style="max-height: 100%; max-width: 100%;">
        <img v-if="imageData" @click="toggleFullScreen" title="Click to toggle full screen mode"
             :src="imageData" alt="An EDAR Generated image."
             style="max-height: 78vh; width: auto; margin: auto;"
             :style="{'cursor': isFullScreen? 'zoom-out':'zoom-in'}"
        >
        <i v-else class="fas fa-sync fa-spin fa-10x" style="margin: auto;"></i>
    </div>
</template>

<script>
    import axios from "axios";
    import urls from "../urls";
    import {Edar} from "../store/modules/edar";
    import ReconnectingWebSocket from 'reconnecting-websocket';

    export default {
        name: "Viewer",
        props: {
            edar: {
                type: [Edar],
                required: true,
            },
        },
        data: () => ({
            //Raw image data
            "imageData": "",
            "carReports": [],
            "imageDataFromWebsocket": false,
            "isFullScreen": false,
            "websocket": null,
        }),
        computed: {
            //Construct an image uri with cache busting
            edarImageUri: function () {
                if(this.carReports.length < 1){
                    return '';
                }
                //Take advantage of the fact there should only be one image per EDAR
                let carReport = this.carReports[0];
                return carReport.image + '?' + carReport.created_at;
            }
        },
        beforeMount() {
            this.getCarReports();
        },
        async mounted() {
            this.connectWebsocket();
        },
        beforeDestroy() {
            this.websocket.close();
        },
        methods: {
            connectWebsocket() {
                let url = new URL(window.location);
                //Allow http for when running locally
                let protocol = "wss";
                if ("http:" === url.protocol) {
                    protocol = "ws";
                }
                this.websocket = new ReconnectingWebSocket(`${protocol}://${url.host}/socket/edar/${this.edar.id}`,
                    [localStorage.getItem('Token')],
                    {
                        maxRetries: 5,
                        // debug: true,
                    });
                this.websocket.onmessage = this.processMessage;
            },
            //Use this so we can seamlessly transition images in the background
            //Versus just using edarImageUri in img.src directly
            async loadImage(uri) {
                if(uri === '') {
                    return;
                }
                try{
                    let response = await axios.get(uri, {responseType: 'blob'});
                    let reader = new FileReader();
                    reader.onloadend = () => {
                        this.imageData = reader.result;
                    };
                    reader.readAsDataURL(response.data);
                } catch (e) {
                    console.log(e.response.status);
                }
            },
            //Get all the images for this Edar
            async getCarReports() {
                let response = await axios.get(urls.edar + this.edar.id + '/image/');
                this.carReports = response.data;
            },
            //Process an incoming message
            processMessage(message) {
                let data = JSON.parse(message.data);
                //Update the list of images only if the data was not sent
                if(typeof(data.carReports) === "object"){
                    this.carReports = data.carReports;
                } else {
                    this.getCarReports();
                }
                //Handle if the websocket sends the image data
                if(typeof(data.imageData) === "object" || typeof(data.imageData) === "string"){
                    this.imageDataFromWebsocket = true;
                    this.imageData = data.imageData;
                } else {
                    this.imageDataFromWebsocket = false;
                }
            },
            //Toggle an element (the image) between full screen or not
            toggleFullScreen(event) {
                if(this.isFullScreen) {
                    document.exitFullscreen();
                    this.isFullScreen = false;
                    return;
                }
                event.target.requestFullscreen();
                this.isFullScreen = true;
            },
        },
        watch: {
            //Reset everything when edar changes, so we don't store old values/receive old data
            //This is not triggered by the initial render
            edar(value) {
                this.websocket.close();

                this.imageData = "";
                this.carReports = [];
                this.imageDataFromWebsocket = false;
                this.websocket = null;

                this.getCarReports();
                this.connectWebsocket();
            },
            async edarImageUri(value) {
                if(!this.imageDataFromWebsocket) {
                    this.loadImage(value);
                }
            },
        },
    }
</script>

<style scoped>

</style>